import { StateCreator } from 'zustand/vanilla';

export const DEFAULT_SEARCH_FIELDS: string[] = [];

export interface SearchFieldsStore {
	searchFields: string[];
	actions: {
		setSearchFields: (value: string[]) => void;
	};
}

export const createSearchFieldsSlice: StateCreator<SearchFieldsStore> = (set) => ({
	searchFields: DEFAULT_SEARCH_FIELDS,
	actions: {
		setSearchFields: (value: string[]) => set(() => ({ searchFields: value })),
	},
});

export const searchFieldsStoreSelector = {
	actions: (state: SearchFieldsStore) => state.actions,
	searchFields: (state: SearchFieldsStore) => state.searchFields,
};
